import { render, staticRenderFns } from "./WithdrawMethodSection.vue?vue&type=template&id=3f66cb00&"
import script from "./WithdrawMethodSection.vue?vue&type=script&lang=js&"
export * from "./WithdrawMethodSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports